<template>
    <div class="big_title syht_bold">
        <p @click="handleClick">联投金融聚合可视化平台</p>
        <div class="twinkle"></div>
    </div>
</template>

<script>
  export default {
    name: 'monitorTitle',
    data() {
      return {

      }
    },
    computed: {

    },
    mounted() {
    },
    components: {

    },
    props: {

    },
    methods: {
        handleClick: function () {
            this.$router.push({
                name: 'LenderHome'
            })
        }
    }
  }
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/views/monitor/partials/MonitorTopTitle.vue